/**
 * Homepage hero presets — Lane 2 (Feb 2026).
 *
 * Dan picks a preset in /admin ("Homepage" tab); the homepage renders
 * whichever preset is active. Copy lives here so wording tweaks are a
 * content change, not a rebuild — but headline text is NEVER typed
 * into production live. He only ever picks a labelled preset.
 *
 * Preset keys are whitelisted on the backend (site_settings.py); keep
 * these two names in lock-step with `_ALLOWED_PRESETS` there.
 */

export const DEFAULT_HERO_PRESET = "summer_general";

export const HERO_PRESETS = {
  summer_general: {
    // "Summer / General" — the current default hero. Copy is verbatim
    // the previous static JSX at AtomicEdu.jsx lines 160 + 166-170.
    // DO NOT rewrite; Preset A must reproduce today's hero exactly.
    label: "Summer / General",
    headline: "Plan, teach, assess, and report — all in one place.",
    subhead:
      "Atomic Edu builds your lessons, units, rubrics, tests, and " +
      "report card comments for Ontario Grades 4\u20138 — so you spend " +
      "less time on prep and paperwork, and walk into class ready " +
      "to teach.",
  },
  report_card_season: {
    label: "Report Card Season",
    headline:
      "The report card writes itself — because it knows what you taught.",
    subhead:
      "Atomic Edu plans your lessons, tracks what you actually teach, " +
      "and turns it into Growing Success-ready report comments. " +
      "Built for Ontario Grades 4\u20138 — by a teacher with 20 years " +
      "in the classroom.",
  },
};

/** Ordered list for admin picker rendering. */
export const HERO_PRESET_ORDER = ["summer_general", "report_card_season"];

/** localStorage key used by the zero-flash reader on the homepage. */
export const HERO_PRESET_STORAGE_KEY = "atomicedu_hero_preset";

/** Safe lookup — falls back to Summer / General for unknown keys. */
export const getHeroPreset = (key) => {
  if (key && Object.prototype.hasOwnProperty.call(HERO_PRESETS, key)) {
    return HERO_PRESETS[key];
  }
  return HERO_PRESETS[DEFAULT_HERO_PRESET];
};
